
define('text!presentation/loginNotifications/views/miscProblems.html',[],function () { return '<div class="login-modal misc-problems">\n    <div class="action-modal__warning-box"\n         data-bind="warningBox: { titleI18nKey: \'miscProblems:warningTitle\' }">\n    </div>\n</div>';});

